import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";

// core components
import styles from "assets/jss/material-kit-pro-react/components/parallaxStyle.js";

const useStyles = makeStyles(styles);

export default function Parallax(props) {
	let windowScrollTop;
	if (window.innerWidth >= 768) {
		windowScrollTop = window.pageYOffset / 3;
	} else {
		windowScrollTop = 0;
	}
	const [transform, setTransform] = React.useState(
		"translate3d(0," + windowScrollTop + "px,0)",
	);
	React.useEffect(() => {
		if (window.innerWidth >= 768) {
			window.addEventListener("scroll", resetTransform);
		}
		return function cleanup() {
			if (window.innerWidth >= 768) {
				window.removeEventListener("scroll", resetTransform);
			}
		};
	});
	const resetTransform = () => {
		var windowScrollTop = window.pageYOffset / 3;
		setTransform("translate3d(0," + windowScrollTop + "px,0)");
	};
	const { filter, className, children, style, image, small, cropFromTop } =
		props;
	const classes = useStyles();
	const parallaxClasses = classNames({
		[classes.parallax]: true,
		[classes[filter + "Color"]]: filter !== undefined,
		[classes.small]: small,
		[className]: className !== undefined,
	});
	// cropFromTop: anchor the image to the top and zoom in. AI-generated
	// category illustrations put the subject's head in the upper third; the
	// default centered crop slices it off on wide viewports. Anchoring to the
	// top and scaling past 100% keeps heads visible and fills the frame.
	const cropStyle = cropFromTop
		? { backgroundPosition: "50% 0%", backgroundSize: "140% auto" }
		: null;
	return (
		<div
			className={parallaxClasses}
			style={{
				...style,
				backgroundImage: "url(" + image + ")",
				transform: transform,
				...cropStyle,
			}}
		>
			{children}
		</div>
	);
}

Parallax.propTypes = {
	className: PropTypes.string,
	filter: PropTypes.oneOf([
		"primary",
		"rose",
		"dark",
		"info",
		"success",
		"warning",
		"danger",
	]),
	children: PropTypes.node,
	style: PropTypes.string,
	image: PropTypes.string,
	small: PropTypes.bool,
	cropFromTop: PropTypes.bool,
};
